import React, { Component, useContext } from 'react'
import logo from '../../images/logo.png'
import MaskedInput from 'antd-mask-input'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Button } from 'antd'
import { AgreementModal } from '../../modals'
import { Timer, CodeInput } from '../../components'
import { AppState } from '../../store'
import { RouteComponentProps } from 'react-router-dom'
import Stores from '../../components/Stores'
import './style.less'
import { checkCodeRequest, demoTokenRequest, sendCodeRequest } from '../../store/reducks/auth/auth.actions'
import { smart_captcha } from '../../tools/smart-captcha'
import { emitter, IConfirmDto } from '../../store/reducks/chat/chat.session'
import { WaitCall } from '../../components/WaitCall'
import { AuthConfigContext } from '../../components/AuthConfigProvider'
import { WaitCallError } from '../../components/WaitCallError'

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = typeof mapDispatchToProps

interface Props extends RouteComponentProps, DispatchProps, StateProps { isSms?: boolean }

interface State {
  showAgreementModal: boolean
  phone: string
  phoneInvalid: boolean
  code: string
  stage: number
  error: boolean
  canSend: boolean
  sending: boolean
}

class LoginView extends Component<Props, State, Props> {
  constructor(props: Props) {
    super(props)
    this.state = {
      showAgreementModal: false,
      phone: '',
      phoneInvalid: true,
      code: '',
      stage: 1,
      error: true,
      canSend: false,
      sending: false,
    }
  }

  componentDidMount() {
    if (!!this.props.auth.token) {
      this.props.history.push('/')
    }
    smart_captcha.show()
    emitter.on('confirmed', this.onConfirmed)
  }

  componentWillUnmount(): void {
    smart_captcha.hide()
    emitter.off('confirmed', this.onConfirmed)
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    const phoneValid = this.parsePhone().length == 10
    if (prevState.phoneInvalid && phoneValid) {
      this.setState({ phoneInvalid: false })
    }
    if (!prevState.phoneInvalid && !phoneValid) {
      this.setState({ phoneInvalid: true })
    }
    const { auth, error } = this.props
    if (auth.stage == 'DEMO' && auth.token && !prevProps.auth.token) {
      this.props.history.replace('/')
    }
    if (prevProps.auth.fetching && !auth.fetching && prevState.stage == 1 && auth.stage != 'LOGOUT') {
      if (!error) {
        this.setState({ stage: 2, canSend: false, sending: false })
      }
    }
    if (prevProps.auth.fetching && !auth.fetching && prevState.stage == 2 && prevState.sending) {
      if (!error) {
        this.setState({ canSend: false, sending: false })
      }
    }
    if (prevProps.auth.fetching && !auth.fetching && prevState.stage == 2 && !prevState.sending) {
      if (!error) {
        this.props.history.push('/')
      }
    }
    if (!prevProps.auth.token && auth.token) {
      this.props.history.push('/')
    }
    const isSessionError = (auth: any) => auth.error && auth.errorData?.code === 'WAITCALL_ERROR_1'
    if (isSessionError(auth) && !isSessionError(prevProps.auth)) {
      this.setState({ stage: 3 })
    }
    const code = this.state.code
    const prevCode = prevState.code
    if (prevCode != code && code.length >= 4 && prevState.stage == 2) {
      this.props.authCheckCodeAction({ phone: this.parsePhone(), code })
    }
  }

  onConfirmed = (data: IConfirmDto) => {
    this.setState({ code: data.wait_phone })
  }

  parsePhone = (): string => {
    return this.state.phone.replace(/[^0-9]+/g, '')
  }

  sendCode() {
    if (this.state.phoneInvalid) return
    this.setState({ sending: true })
    this.props.authSendCodeAction({ phone: this.parsePhone() })
  }

  render() {
    const { phone, phoneInvalid, showAgreementModal, stage, canSend } = this.state
    const { auth, isSms: IS_SMS } = this.props
    const stage1 = (
      <>
        <p className="description">
          Пожалуйста, зарегистрируйтесь для получения
          <br />
          информации о клинике и записи на прием
        </p>
        <div className="phone-input">
          <MaskedInput
            prefix="+7"
            value={phone}
            mask="(111) 111-11-11"
            placeholder="номер телефона"
            onPressEnter={() => {
              this.sendCode()
            }}
            onChange={(e) => {
              this.setState({ phone: e.target.value })
            }}
            size="large"
          />
          <Button
            size="large"
            type="primary"
            disabled={phoneInvalid}
            onClick={() => {
              this.sendCode()
            }}
          >
            {IS_SMS ? 'Отправить код' : 'Войти'}
          </Button>
        </div>
        <p
          className="agreement"
          onClick={() => {
            this.setState({ showAgreementModal: true })
          }}
        >
          Нажимая на кнопку "Войти", я даю согласие <br />на{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              this.setState({ showAgreementModal: true })
            }}
          >
            обработку персональных данных
          </a>
        </p>
        <p
          className="demo-login"
          onClick={() => {
            this.props.demoTokenRequest()
          }}
        >
          {'ДЕМО-РЕЖИМ'}
        </p>
      </>
    )
    const stage2Sms = (
      <>
        <p className="description">
          Мы отправили СМС с кодом на
          <br />
          номер <strong>+7 {phone}.</strong>{' '}
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault()
              this.setState({ stage: 1, phone: '', code: '' })
            }}
          >
            Изменить
          </a>
        </p>
        <CodeInput
          className="code"
          onChange={(code) => {
            this.setState({ code })
          }}
        />
        <Button
          className="send"
          disabled={!canSend}
          type="link"
          onClick={() => {
            this.setState({ sending: true })
            this.props.authSendCodeAction({ phone: this.parsePhone() })
          }}
        >
          {!canSend ? (
            <>
              Отправить повторно через&nbsp;
              <Timer
                duration={60}
                onDone={() => {
                  this.setState({ canSend: true })
                }}
              />
            </>
          ) : (
            <>Отправить повторно</>
          )}
        </Button>
      </>
    )
    const stage2Call = (
      <WaitCall
        phone={phone}
        waitPhone={auth.waitPhone as string}
        expireAt={auth.expireAt as string}
        onChangePhone={() => {
          this.setState({ stage: 1, phone: '', code: '' })
        }}
      />
    )
    const stage2 = IS_SMS || !auth.waitPhone ? stage2Sms : stage2Call
    const stage3 = (
      <WaitCallError
        expireAt={auth.errorData?.expire_at}
        onTimeout={() => {
          this.setState({ stage: 1, code: '' })
        }}
        onBack={() => {
          this.setState({ stage: 1, code: '' })
        }}
      />
    )
    return (
      <div className="login">
        <div className="main">
          <div className="logo">
            <img src={logo} alt="" />
          </div>
          <div className="form">
            <div className={"body " + (stage === 3 ? 'error' : '')}>
              <h2>{stage == 3 ? 'Ошибка входа' : 'Вход в личный кабинет'}</h2>
              {stage == 1 ? stage1 : (stage == 3 ? stage3 : stage2)}
            </div>
            <div className="footer">
              <p>Также вы можете воспользоваться нашим мобильным приложением</p>
              <Stores />
            </div>
          </div>
        </div>
        <div id="captcha"></div>
        <AgreementModal
          onCancel={() => {
            this.setState({ showAgreementModal: false })
          }}
          show={showAgreementModal}
        />
      </div>
    )
  }
}

const mapStateToProps = (state: AppState) => ({
  auth: state.auth,
  error: state.auth.error,
})

const mapDispatchToProps = {
  authSendCodeAction: sendCodeRequest,
  authCheckCodeAction: checkCodeRequest,
  demoTokenRequest,
}

const _LoginView: React.FC = (props: any) => {
  const auth = useContext(AuthConfigContext)
  return <LoginView {...props} isSms={auth?.authType === 'sms'}/>
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(_LoginView))
